/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataManualInfoUserResVo } from './NodataManualInfoUserResVo';
import {
    NodataManualInfoUserResVoFromJSON,
    NodataManualInfoUserResVoFromJSONTyped,
    NodataManualInfoUserResVoToJSON,
    NodataManualInfoUserResVoToJSONTyped,
} from './NodataManualInfoUserResVo';

/**
 * 
 * @export
 * @interface ResponseNodataManualInfoUserResVo
 */
export interface ResponseNodataManualInfoUserResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseNodataManualInfoUserResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseNodataManualInfoUserResVo
     */
    message?: string;
    /**
     * 
     * @type {NodataManualInfoUserResVo}
     * @memberof ResponseNodataManualInfoUserResVo
     */
    data?: NodataManualInfoUserResVo;
}

/**
 * Check if a given object implements the ResponseNodataManualInfoUserResVo interface.
 */
export function instanceOfResponseNodataManualInfoUserResVo(value: object): value is ResponseNodataManualInfoUserResVo {
    return true;
}

export function ResponseNodataManualInfoUserResVoFromJSON(json: any): ResponseNodataManualInfoUserResVo {
    return ResponseNodataManualInfoUserResVoFromJSONTyped(json, false);
}

export function ResponseNodataManualInfoUserResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseNodataManualInfoUserResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : NodataManualInfoUserResVoFromJSON(json['data']),
    };
}

export function ResponseNodataManualInfoUserResVoToJSON(json: any): ResponseNodataManualInfoUserResVo {
    return ResponseNodataManualInfoUserResVoToJSONTyped(json, false);
}

export function ResponseNodataManualInfoUserResVoToJSONTyped(value?: ResponseNodataManualInfoUserResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': NodataManualInfoUserResVoToJSON(value['data']),
    };
}

